module.exports = __webpack_public_path__ + "static/media/Categorytooltipimage.c4c9026f.png";